<template>
  <el-table-column
    :label="label"
    :prop="prop"
    :class-name="className"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <!-- <i v-if='billingExclusive(scope.row, scope.$index)' class="el-icon-error"></i> -->
      <i v-if='billingExclusive(scope.row, scope.$index)' class="el-icon-check"></i>
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '除外'
    },
    prop: {
      type: String,
      default: 'billing_exclusion_flag'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'billing_exclusion_flag'
    },
    billingExclusive: {
      type: Function,
      default: () => false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.billing_exclusion_flag {
      width: 6em;
    }
  }
  i.el-icon-success {
    font-size: 1.7em;
    color: #3cb371;
  }
  i.el-icon-error {
    font-size: 1.7em;
    color: #dc143c;
  }
}
</style>
